import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import styled from 'styled-components';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { MAX_VALUE_DEFAULT, MIN_VALUE_DEFAULT } from './constants.js';
import { Lateral } from './Lateral/Lateral.js';
import { Radial } from './Radial/Radial.js';
import { ProgressBarStatus } from './types.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["direction", "isIndeterminate", "statusText", "value", "valueText", "variant"];
var Container = styled.div.withConfig({
  displayName: "ProgressBar__Container",
  componentId: "sc-1tlltkh-0"
})(["&&{display:", ";}"], function (_ref) {
  var displayInline = _ref.displayInline;
  return displayInline ? "inline-block" : "block";
});
var ProgressBar = function ProgressBar(props) {
  var _rest$ariaValuemin, _rest$ariaValuemax;
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? "lateral" : _props$direction,
    _props$isIndeterminat = props.isIndeterminate,
    isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat,
    statusText = props.statusText,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    valueText = props.valueText,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "default" : _props$variant,
    rest = _objectWithoutProperties(props, _excluded);
  var valueMin = (_rest$ariaValuemin = rest["aria-valuemin"]) !== null && _rest$ariaValuemin !== void 0 ? _rest$ariaValuemin : MIN_VALUE_DEFAULT;
  var valueMax = (_rest$ariaValuemax = rest["aria-valuemax"]) !== null && _rest$ariaValuemax !== void 0 ? _rest$ariaValuemax : MAX_VALUE_DEFAULT;
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var parsedValue = Math.max(valueMin, Math.min(value, valueMax));
  var parsedValuePercentage = Math.round((parsedValue - valueMin) / (valueMax - valueMin) * 100);
  var parsedValuePercentageText = isIndeterminate ? "" : "".concat(parsedValuePercentage, "%");
  var valueTextFinal = valueText !== void 0 ? valueText : parsedValuePercentageText;
  var isCompleted = value >= valueMax;
  var status;
  var ariaValueText;
  switch (variant) {
    case "error":
      ariaValueText = t("ProgressBar.error");
      status = ProgressBarStatus.error;
      break;
    case "default":
      if (isIndeterminate) {
        status = isCompleted ? ProgressBarStatus.success : ProgressBarStatus.indeterminate;
      } else {
        ariaValueText = "".concat(statusText ? statusText : "", " ").concat(valueTextFinal);
        status = isCompleted ? ProgressBarStatus.success : ProgressBarStatus.progress;
      }
      break;
  }
  var content;
  switch (direction) {
    case "lateral":
      content = /*#__PURE__*/jsx(Lateral, {
        status: status,
        statusText: statusText,
        valuePercentage: parsedValuePercentage,
        valueText: valueTextFinal
      });
      break;
    case "radial":
      content = /*#__PURE__*/jsx(Radial, {
        status: status,
        statusText: statusText,
        valuePercentage: parsedValuePercentage,
        valueText: parsedValuePercentageText
      });
      break;
  }
  return /*#__PURE__*/jsx(Container, _objectSpread(_objectSpread({
    "aria-valuenow": isIndeterminate ? void 0 : value,
    "aria-valuetext": ariaValueText,
    displayInline: direction === "radial",
    role: "progressbar",
    tabIndex: 0
  }, rest), {}, {
    children: content
  }));
};
ProgressBar.displayName = "ProgressBar";

export { ProgressBar };
